export default "__VITE_ASSET__be0ea754__"